export const SELECTION_CARD_GROUP_UNIQUE_NAME_PREFIX = "fs-radiogroup";
export const SELECTION_CARD_LABEL_ID_PREFIX = "fs-selection-card-label-";
export const SELECTION_CARD_DESCRIPTION_ID_PREFIX =
  "fs-selection-card-description-";
